export const getWindowTitle = (text: string = '') => {
    return text ? `${text} - Leveransbevis - Beijer` : "Leveransbevis - Beijer"
}